(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("bin-ui", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["bin-ui"] = factory(require("vue"));
	else
		root["bin-ui"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__47__) {
return 